










































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import SortingList from '@morpheus/utils/admin-vue/mixins/sortingList'
import AppDialogConfirm from '@morpheus/utils/admin-vue/components/AppDialogConfirm.vue'
import AppDialogPrompt from '@morpheus/utils/admin-vue/components/AppDialogPrompt.vue'
import { UsersListItemData } from '../types'

export default mixins(SortingList).extend({
  name: 'UsersList',
  components: {
    AppDialogConfirm,
    AppDialogPrompt
  },
  mixins: [ SortingList ],
  props: {
    headers: {
      required: true,
      type: Array as () => Array<any>
    },
    items: {
      required: true,
      type: Array as () => Array<UsersListItemData>
    },
    totalItems: {
      required: true,
      type: Number
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      deleteMessage: '',
      userToDelete: '',
      banDialog: false,
      userToBan: '',
      banStatus: true
    }
  },
  methods: {
    deleteUser (event: any, id: string, itemName: string) {
      this.deleteMessage = `Are you sure you want to delete user ${itemName}?`
      this.userToDelete = id
    },
    confirmDeleteUser (confirmation: boolean) {
      this.deleteMessage = ''

      if (confirmation) {
        this.$emit('onDeleteUser', this.userToDelete)
      }
    },
    banUser (event: any, id: string, status: boolean) {
      this.banDialog = true
      this.banStatus = status
      this.userToBan = id
    },
    cancelBanUser () {
      this.banDialog = false
    },
    confirmBanUser (reason: string) {
      this.banDialog = false
      this.$emit('onBanUser', this.userToBan, this.banStatus, reason)
    }
  }
})
